<div class="container-fluid glb-popup">
  <h2>{{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>

    <!-- Generated Tracking URL -->
    @if (generatedTrackingUrl) {
      <div class="tracking-url-box">
        <label>Tracking URL</label>
        <div class="tracking-url-row">
          <input type="text" pInputText [value]="generatedTrackingUrl" readonly class="tracking-url-input">
          <button pButton class="p-button-outlined p-button-sm" (click)="copyTrackingUrl()" title="Copy">
            <i class="pi pi-copy"></i> Copy
          </button>
        </div>
      </div>
    }

    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        @if (formAlert) {
          <div class="col-lg-12">
            <div class="w-100 mb-3">
              <div class="w-100" style="text-align: center; background-color: yellow; padding:5px; margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          </div>
        }

        <!-- Destination URL -->
        <div class="col-lg-12">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="destinationUrl" id="destinationUrl" type="text" pInputText class="w-100">
            <label for="destinationUrl">Destination URL</label>
            @for (validation of validationMessages.destinationUrl; track validation) {
              <span>
                @if (form1.get('destinationUrl').hasError(validation.type) && (form1.get('destinationUrl').dirty || form1.get('destinationUrl').touched)) {
                  <small class="p-invalid"
                    >
                    {{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!-- Tracking Mode -->
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown class="w-100" [options]="trackingModes" formControlName="trackingMode"
            optionLabel="name" optionValue="value" placeholder="Tracking Mode"></p-dropdown>
            <label for="trackingMode">Tracking Mode</label>
            @for (validation of validationMessages.trackingMode; track validation) {
              <span>
                @if (form1.get('trackingMode').hasError(validation.type) && (form1.get('trackingMode').dirty || form1.get('trackingMode').touched)) {
                  <small class="p-invalid"
                    >
                    {{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!-- Source Type -->
        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown class="w-100" [options]="sourceTypes" formControlName="sourceType"
            optionLabel="name" optionValue="value" placeholder="Source Type"></p-dropdown>
            <label for="sourceType">Source Type</label>
            @for (validation of validationMessages.sourceType; track validation) {
              <span>
                @if (form1.get('sourceType').hasError(validation.type) && (form1.get('sourceType').dirty || form1.get('sourceType').touched)) {
                  <small class="p-invalid"
                    >
                    {{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <!-- Status (edit only) -->
        @if (trackedLinkId) {
          <div class="col-lg-6">
            <span class="p-float-label w-100 mb-3">
              <p-dropdown class="w-100" [options]="statuses" formControlName="status"
              optionLabel="name" optionValue="value" placeholder="Status"></p-dropdown>
              <label for="status">Status</label>
            </span>
          </div>
        }

        <!-- Name -->
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="name" id="name" type="text" pInputText class="w-100">
            <label for="name">Link Name</label>
          </span>
        </div>

        <!-- Source Name -->
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="sourceName" id="sourceName" type="text" pInputText class="w-100">
            <label for="sourceName">Source Name (e.g. Instagram Bio March 2026)</label>
          </span>
        </div>

        <!-- Tags -->
        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <input formControlName="tags" id="tags" type="text" pInputText class="w-100">
            <label for="tags">Tags (comma-separated)</label>
          </span>
        </div>

        <!-- Description -->
        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="description" id="description" [rows]="2" pInputTextarea class="w-100"></textarea>
            <label for="description">Description</label>
          </span>
        </div>

      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              @if (trackedLinkId) {
                <button pButton class="btn-delete p-button-outlined p-button-danger"
                (click)="onFormDelete()">Archive</button>
              }
            </div>
            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
              @if (!trackedLinkId) {
                <button pButton class="btn-addt p-button" (click)="formAdd()"
                [loading]="formLoading">Create Link</button>
              }
              @if (trackedLinkId) {
                <button pButton class="btn-upt p-button" (click)="formUpdate()"
                [loading]="formLoading">Update</button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
